import { registerPlugin } from '@capacitor/core';

import type { CapacitorNativeSupportPlugin } from './definitions';
import { CapacitorNativeSupportWeb } from './web';

export const CapacitorNativeSupport = registerPlugin<CapacitorNativeSupportPlugin>(
    'CapacitorNativeSupport', { web: () => new CapacitorNativeSupportWeb(), });

export * from './definitions';
